
// // product-card-handler.js - Optimizado para LCP
// (function() {
//   'use strict';

//   // Cache de selectores frecuentes
//   const SELECTORS = {
//     card: '.trending-products__card',
//     discoveryCard: '.discovery-set-card',
//     cartBubble: '.cart-bubble__text-count',
//     cartDrawer: '[data-cart-drawer],#CartDrawer,.cart-drawer,.mini-cart,cart-drawer,cart-notification'
//   };

//   // Formatear precio (optimizado)
//   const formatPrice = (amount) => {
//     const num = parseInt(amount, 10);
//     return isNaN(num) ? '' : '$' + num;
//   };

//   // Recargar sección del carrito
//   function reloadCartSection() {
//     return fetch(`${window.location.href}?section_id=header`)
//       .then(r => r.text())
//       .then(html => {
//         const temp = document.createElement('div');
//         temp.innerHTML = html;
        
//         const newBubble = temp.querySelector('#cart-bubble-text');
//         const oldBubble = document.getElementById('cart-bubble-text');
        
//         if (oldBubble && newBubble) {
//           oldBubble.outerHTML = newBubble.outerHTML;
//           return true;
//         }
        
//         const newHeader = temp.querySelector('header,.site-header,[role="banner"]');
//         const oldHeader = document.querySelector('header,.site-header,[role="banner"]');
        
//         if (oldHeader && newHeader) {
//           oldHeader.innerHTML = newHeader.innerHTML;
//           return true;
//         }
//         return false;
//       })
//       .catch(() => false);
//   }

//   // Actualizar contador del carrito
//   function updateCartCount() {
//     return fetch('/cart.js')
//       .then(r => r.ok ? r.json() : Promise.reject())
//       .then(cart => {
//         const countEl = document.querySelector(SELECTORS.cartBubble);
//         if (countEl) {
//           countEl.textContent = cart.item_count;
//           countEl.classList.toggle('hidden', cart.item_count === 0);
//         }
        
//         const evt = new CustomEvent('cart:updated', { detail: { cart } });
//         document.dispatchEvent(evt);
//         document.dispatchEvent(new CustomEvent('theme:cart:updated', { detail: { cart } }));
//         return cart;
//       })
//       .catch(e => console.error('Cart update error:', e));
//   }

//   // Actualización manual como fallback
//   function updateCartManually(cart) {
//     document.dispatchEvent(new CustomEvent('cart:refresh'));
//     const evt = new CustomEvent('cart:updated', { detail: { cart } });
//     document.dispatchEvent(evt);
//     window.dispatchEvent(evt);
    
//     const elements = document.querySelectorAll(
//       '.cart-bubble__text-count,[data-testid="cart-bubble"],[ref="cartBubbleCount"],#cart-bubble-text .cart-bubble__text-count'
//     );
    
//     elements.forEach(el => {
//       el.textContent = cart.item_count;
//       const parent = el.closest('.cart-bubble__text');
//       const hidden = parent?.querySelector('.visually-hidden');
//       if (hidden) hidden.textContent = `Total items in cart: ${cart.item_count}`;
//     });
    
//     updateCartDrawer(cart);
//   }

//   // Actualizar drawer del carrito
//   function updateCartDrawer(cart) {
//     const selectors = ['[data-cart-drawer]','#CartDrawer','.cart-drawer','.mini-cart','cart-drawer','cart-notification'];
    
//     for (const selector of selectors) {
//       const drawer = document.querySelector(selector);
//       if (drawer) {
//         drawer.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart } }));
        
//         fetch(window.location.href)
//           .then(r => r.text())
//           .then(html => {
//             const doc = new DOMParser().parseFromString(html, 'text/html');
//             const newDrawer = doc.querySelector(selector);
//             if (newDrawer) {
//               drawer.innerHTML = newDrawer.innerHTML;
//               drawer.querySelectorAll('script').forEach(script => {
//                 const ns = document.createElement('script');
//                 ns.textContent = script.textContent;
//                 script.replaceWith(ns);
//               });
//             }
//           })
//           .catch(() => {});
//         return;
//       }
//     }
    
//     const component = document.querySelector('cart-drawer,cart-notification');
//     if (component?.renderContents) component.renderContents(cart);
//   }

//   // Abrir cart drawer
//   function openCartDrawer() {
//     const icon = document.querySelector('[data-cart-icon],.header__icon--cart,.cart-link');
//     if (icon) { icon.click(); return true; }
    
//     document.dispatchEvent(new CustomEvent('cart:open'));
    
//     const drawer = document.querySelector('[data-cart-drawer],#CartDrawer,.cart-drawer');
//     if (drawer) {
//       drawer.classList.add('is-open', 'active');
//       drawer.setAttribute('aria-hidden', 'false');
//       return true;
//     }
//     return false;
//   }

//   // Actualizar precios en la tarjeta
//   function updatePrices(card, price, comparePrice) {
//     const displayPrice = formatPrice(price);
    
//     card.querySelectorAll('.trending-products__price[data-no-format],.unit-price[data-no-format],.total-price[data-no-format],.discovery-set-price-value')
//       .forEach(el => el.textContent = displayPrice);
    
//     const compare = card.querySelector('.trending-products__price--compare');
//     if (compare) {
//       const show = comparePrice && parseInt(comparePrice, 10) > parseInt(price, 10);
//       compare.textContent = show ? formatPrice(comparePrice) : '';
//       compare.style.display = show ? 'inline' : 'none';
//     }
//   }

//   // Inicializar tarjeta individual
//   function initializeCard(card) {
//     if (!card || card.dataset.initialized === 'true') return;
//     card.dataset.initialized = 'true';

//     const selectElements = card.querySelectorAll('.trending-products__select');
//     let initialPrice = null, initialComparePrice = null, initialVariantId = null;

//     if (selectElements.length) {
//       const firstSelect = selectElements[0];
//       const selectedOpt = firstSelect.selectedOptions[0] || firstSelect.options[0];
      
//       if (selectedOpt) {
//         initialPrice = selectedOpt.dataset.price;
//         initialComparePrice = selectedOpt.dataset.comparePrice;
//         initialVariantId = selectedOpt.value;
//       }

//       if (initialPrice) updatePrices(card, initialPrice, initialComparePrice);

//       if (initialVariantId) {
//         card.querySelectorAll('.product-url-link').forEach(link => {
//           if (link.href) {
//             const url = new URL(link.href, location.origin);
//             url.searchParams.set('variant', initialVariantId);
//             link.href = url.toString();
//           }
//         });
//       }

//       // Event delegation para selects
//       selectElements.forEach(select => {
//         if (select.dataset.listenerAdded) return;
//         select.dataset.listenerAdded = 'true';

//         select.addEventListener('change', function() {
//           const opt = this.selectedOptions[0];
//           const price = opt.dataset.price || initialPrice;
//           const comparePrice = opt.dataset.comparePrice;
//           const variantId = opt.value;

//           updatePrices(card, price, comparePrice);

//           card.querySelectorAll('.product-url-link').forEach(link => {
//             if (link.href && variantId) {
//               const url = new URL(link.href, location.origin);
//               url.searchParams.set('variant', variantId);
//               link.href = url.toString();
//             }
//           });

//           // Sincronizar selects
//           const productId = this.dataset.productId;
//           card.querySelectorAll(`.trending-products__select[data-product-id="${productId}"]`).forEach(s => {
//             if (s !== this) s.value = variantId;
//           });

//           card.querySelectorAll('.trending-products__btn').forEach(btn => {
//             btn.dataset.variantId = variantId;
//             btn.disabled = opt.dataset.available !== 'true';
//           });
//         });
//       });
//     }

//     // Wishlist
//     card.querySelector('.trending-products__wishlist')?.addEventListener('click', function(e) {
//       e.preventDefault();
//       e.stopPropagation();
//       this.classList.toggle('active');
//     });

//     // Añadir al carrito
//     card.querySelector('.trending-products__btn--cart')?.addEventListener('click', function(e) {
//       e.preventDefault();
//       e.stopPropagation();
      
//       const btn = this;
//       const originalHTML = btn.innerHTML;
//       const select = card.querySelector('.trending-products__select');
//       const variantId = select?.value || btn.dataset.variantId;
//       const qty = parseInt(card.querySelector('.quantity-input')?.value) || 1;
      
//       if (!variantId) { alert('Please select a variant.'); return; }
      
//       btn.disabled = true;
//       btn.innerHTML = 'ADDING...';
      
//       fetch('/cart/add.js', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
//         body: JSON.stringify({ id: variantId, quantity: qty })
//       })
//       .then(r => r.ok ? r.json() : Promise.reject())
//       .then(() => {
//         btn.innerHTML = '✓ ADDED';
//         btn.style.background = '#4CAF50';
//         updateCartCount().then(() => setTimeout(openCartDrawer, 300));
//         setTimeout(() => { btn.disabled = false; btn.innerHTML = originalHTML; btn.style.background = ''; }, 2000);
//       })
//       .catch(() => {
//         btn.disabled = false;
//         btn.innerHTML = originalHTML;
//         alert('Error adding product to cart. Please try again.');
//       });
//     });

//     // Comprar ahora
//     card.querySelector('.trending-products__btn--buy')?.addEventListener('click', function(e) {
//       e.preventDefault();
//       e.stopPropagation();
      
//       const select = card.querySelector('.trending-products__select');
//       const variantId = select?.value || this.dataset.variantId;
      
//       if (!variantId) { alert('Please select a variant.'); return; }
      
//       this.disabled = true;
//       this.innerHTML = 'PROCESSING...';
//       buyNowSingle(variantId, 1);
//     });

//     // Tooltips verticales
//     initTooltip(card, '.notes', '.ribbon', '.custom-tooltip', '#card_details', 
//       { show: ['active-tooltip', 'blur'], hide: ['card_details'] });

//     // Tooltips horizontales
//     initTooltip(card, '.notes1-horizantal', '.ribbon1-horizantal', '.custom-tooltip-horizontal', '#card-horizontal',
//       { show: ['active-tooltip-horizantal', 'blur-horizantal'], hide: [] });
//   }

//   // Inicializar tooltips (reutilizable)
//   function initTooltip(card, containerSel, ribbonSel, tooltipSel, detailsSel, classes) {
//     const container = card.querySelector(containerSel);
//     if (!container) return;
    
//     const ribbon = container.querySelector(ribbonSel);
//     const tooltip = container.querySelector(tooltipSel);
//     const details = card.querySelector(detailsSel);
    
//     if (!ribbon || !tooltip || !details) return;

//     const show = () => {
//       tooltip.style.display = 'block';
//       ribbon.classList.add(classes.show[0]);
//       details.classList.add(classes.show[1]);
//       classes.hide.forEach(c => details.classList.remove(c));
//     };

//     const hide = () => {
//       setTimeout(() => {
//         if (!ribbon.matches(':hover') && !tooltip.matches(':hover')) {
//           tooltip.style.display = 'none';
//           ribbon.classList.remove(classes.show[0]);
//           details.classList.remove(classes.show[1]);
//           classes.hide.forEach(c => details.classList.add(c));
//         }
//       }, 100);
//     };

//     container.addEventListener('mouseenter', show);
//     container.addEventListener('mouseleave', hide);
//     tooltip.addEventListener('mouseenter', show);
//     tooltip.addEventListener('mouseleave', hide);
//   }

//   // Inicializar Discovery Cards
//   function initDiscoveryCards() {
//     document.querySelectorAll(SELECTORS.discoveryCard).forEach(card => {
//       card.querySelector('.discovery-set-btn--cart')?.addEventListener('click', async function(e) {
//         e.preventDefault();
//         const btn = this;
//         const originalText = btn.textContent;
//         const variantId = btn.dataset.variantId;
        
//         btn.disabled = true;
//         btn.textContent = 'ADDING...';
        
//         try {
//           const r = await fetch('/cart/add.js', {
//             method: 'POST',
//             headers: { 'Content-Type': 'application/json' },
//             body: JSON.stringify({ id: variantId, quantity: 1 })
//           });
          
//           if (r.ok) {
//             const data = await r.json();
//             const count = document.querySelector('.cart-count,[data-cart-count]');
//             if (count) {
//               const cart = await fetch('/cart.js').then(r => r.json());
//               count.textContent = cart.item_count;
//             }
//             btn.textContent = '✓ ADDED';
//             setTimeout(() => { btn.textContent = originalText; btn.disabled = false; }, 2000);
//             document.dispatchEvent(new CustomEvent('cart:updated', { detail: { item: data } }));
//           } else throw new Error();
//         } catch {
//           btn.textContent = 'ERROR';
//           setTimeout(() => { btn.textContent = originalText; btn.disabled = false; }, 2000);
//         }
//       });

//       card.querySelector('.discovery-set-btn--buy')?.addEventListener('click', async function(e) {
//         e.preventDefault();
//         const btn = this;
//         const originalText = btn.textContent;
        
//         btn.disabled = true;
//         btn.textContent = 'PROCESSING...';
        
//         try {
//           const r = await fetch('/cart/add.js', {
//             method: 'POST',
//             headers: { 'Content-Type': 'application/json' },
//             body: JSON.stringify({ id: btn.dataset.variantId, quantity: 1 })
//           });
//           if (r.ok) location.href = '/checkout';
//           else throw new Error();
//         } catch {
//           btn.textContent = 'ERROR';
//           setTimeout(() => { btn.textContent = originalText; btn.disabled = false; }, 2000);
//         }
//       });
//     });
//   }

//   // Inicializar todas las tarjetas
//   function initializeAllCards() {
//     document.querySelectorAll(SELECTORS.card).forEach(initializeCard);
//     initDiscoveryCards();
//   }

//   // MutationObserver optimizado
//   function setupObserver() {
//     let pending = [];
//     let scheduled = false;

//     const processPending = () => {
//       pending.forEach(initializeCard);
//       pending = [];
//       scheduled = false;
//     };

//     new MutationObserver(mutations => {
//       for (const m of mutations) {
//         for (const node of m.addedNodes) {
//           if (node.nodeType !== 1) continue;
//           if (node.matches?.(SELECTORS.card)) pending.push(node);
//           node.querySelectorAll?.(SELECTORS.card).forEach(c => pending.push(c));
//         }
//       }
//       if (pending.length && !scheduled) {
//         scheduled = true;
//         requestAnimationFrame(processPending);
//       }
//     }).observe(document.body, { childList: true, subtree: true });
//   }

//   // ========== CLAVE PARA LCP: Diferir inicialización ==========
//   function init() {
//     initializeAllCards();
//     setupObserver();
//   }

//   // Ejecutar DESPUÉS del LCP
//   if ('requestIdleCallback' in window) {
//     requestIdleCallback(init, { timeout: 2500 });
//   } else {
//     // Fallback: doble rAF para asegurar que el paint ocurrió
//     requestAnimationFrame(() => requestAnimationFrame(init));
//   }

//   // API global
//   window.initializeProductCards = initializeAllCards;
//   window.updateCartCount = updateCartCount;
// })();


(function(){'use strict';const SELECTORS={card:'.trending-products__card',discoveryCard:'.discovery-set-card',cartBubble:'.cart-bubble__text-count',cartDrawer:'[data-cart-drawer],#CartDrawer,.cart-drawer,.mini-cart,cart-drawer,cart-notification'};const formatPrice=(amount)=>{const num=parseInt(amount,10);return isNaN(num)?'':'$'+num};function reloadCartSection(){return fetch(`${window.location.href}?section_id=header`).then(r=>r.text()).then(html=>{const temp=document.createElement('div');temp.innerHTML=html;const newBubble=temp.querySelector('#cart-bubble-text');const oldBubble=document.getElementById('cart-bubble-text');if(oldBubble&&newBubble){oldBubble.outerHTML=newBubble.outerHTML;return!0}
const newHeader=temp.querySelector('header,.site-header,[role="banner"]');const oldHeader=document.querySelector('header,.site-header,[role="banner"]');if(oldHeader&&newHeader){oldHeader.innerHTML=newHeader.innerHTML;return!0}
return!1}).catch(()=>!1)}
function updateCartCount(){return fetch('/cart.js').then(r=>r.ok?r.json():Promise.reject()).then(cart=>{const countEl=document.querySelector(SELECTORS.cartBubble);if(countEl){countEl.textContent=cart.item_count;countEl.classList.toggle('hidden',cart.item_count===0)}
const evt=new CustomEvent('cart:updated',{detail:{cart}});document.dispatchEvent(evt);document.dispatchEvent(new CustomEvent('theme:cart:updated',{detail:{cart}}));return cart}).catch(e=>console.error('Cart update error:',e))}
function updateCartManually(cart){document.dispatchEvent(new CustomEvent('cart:refresh'));const evt=new CustomEvent('cart:updated',{detail:{cart}});document.dispatchEvent(evt);window.dispatchEvent(evt);const elements=document.querySelectorAll('.cart-bubble__text-count,[data-testid="cart-bubble"],[ref="cartBubbleCount"],#cart-bubble-text .cart-bubble__text-count');elements.forEach(el=>{el.textContent=cart.item_count;const parent=el.closest('.cart-bubble__text');const hidden=parent?.querySelector('.visually-hidden');if(hidden)hidden.textContent=`Total items in cart: ${cart.item_count}`});updateCartDrawer(cart)}
function updateCartDrawer(cart){const selectors=['[data-cart-drawer]','#CartDrawer','.cart-drawer','.mini-cart','cart-drawer','cart-notification'];for(const selector of selectors){const drawer=document.querySelector(selector);if(drawer){drawer.dispatchEvent(new CustomEvent('cart:refresh',{detail:{cart}}));fetch(window.location.href).then(r=>r.text()).then(html=>{const doc=new DOMParser().parseFromString(html,'text/html');const newDrawer=doc.querySelector(selector);if(newDrawer){drawer.innerHTML=newDrawer.innerHTML;drawer.querySelectorAll('script').forEach(script=>{const ns=document.createElement('script');ns.textContent=script.textContent;script.replaceWith(ns)})}}).catch(()=>{});return}}
const component=document.querySelector('cart-drawer,cart-notification');if(component?.renderContents)component.renderContents(cart);}
function openCartDrawer(){const icon=document.querySelector('[data-cart-icon],.header__icon--cart,.cart-link');if(icon){icon.click();return!0}
document.dispatchEvent(new CustomEvent('cart:open'));const drawer=document.querySelector('[data-cart-drawer],#CartDrawer,.cart-drawer');if(drawer){drawer.classList.add('is-open','active');drawer.setAttribute('aria-hidden','false');return!0}
return!1}
function updatePrices(card,price,comparePrice){const displayPrice=formatPrice(price);card.querySelectorAll('.trending-products__price[data-no-format],.unit-price[data-no-format],.total-price[data-no-format],.discovery-set-price-value').forEach(el=>el.textContent=displayPrice);const compare=card.querySelector('.trending-products__price--compare');if(compare){const show=comparePrice&&parseInt(comparePrice,10)>parseInt(price,10);compare.textContent=show?formatPrice(comparePrice):'';compare.style.display=show?'inline':'none'}}
function initializeCard(card){if(!card||card.dataset.initialized==='true')return;card.dataset.initialized='true';const selectElements=card.querySelectorAll('.trending-products__select');let initialPrice=null,initialComparePrice=null,initialVariantId=null;if(selectElements.length){const firstSelect=selectElements[0];const selectedOpt=firstSelect.selectedOptions[0]||firstSelect.options[0];if(selectedOpt){initialPrice=selectedOpt.dataset.price;initialComparePrice=selectedOpt.dataset.comparePrice;initialVariantId=selectedOpt.value}
if(initialPrice)updatePrices(card,initialPrice,initialComparePrice);if(initialVariantId){card.querySelectorAll('.product-url-link').forEach(link=>{if(link.href){const url=new URL(link.href,location.origin);url.searchParams.set('variant',initialVariantId);link.href=url.toString()}})}
selectElements.forEach(select=>{if(select.dataset.listenerAdded)return;select.dataset.listenerAdded='true';select.addEventListener('change',function(){const opt=this.selectedOptions[0];const price=opt.dataset.price||initialPrice;const comparePrice=opt.dataset.comparePrice;const variantId=opt.value;updatePrices(card,price,comparePrice);card.querySelectorAll('.product-url-link').forEach(link=>{if(link.href&&variantId){const url=new URL(link.href,location.origin);url.searchParams.set('variant',variantId);link.href=url.toString()}});const productId=this.dataset.productId;card.querySelectorAll(`.trending-products__select[data-product-id="${productId}"]`).forEach(s=>{if(s!==this)s.value=variantId});card.querySelectorAll('.trending-products__btn').forEach(btn=>{btn.dataset.variantId=variantId;btn.disabled=opt.dataset.available!=='true'})})})}
card.querySelector('.trending-products__wishlist')?.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();this.classList.toggle('active')});card.querySelector('.trending-products__btn--cart')?.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();const btn=this;const originalHTML=btn.innerHTML;const select=card.querySelector('.trending-products__select');const variantId=select?.value||btn.dataset.variantId;const qty=parseInt(card.querySelector('.quantity-input')?.value)||1;if(!variantId){alert('Please select a variant.');return}
btn.disabled=!0;btn.innerHTML='ADDING...';fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:variantId,quantity:qty})}).then(r=>r.ok?r.json():Promise.reject()).then(()=>{btn.innerHTML='✓ ADDED';btn.style.background='#4CAF50';updateCartCount().then(()=>setTimeout(openCartDrawer,300));setTimeout(()=>{btn.disabled=!1;btn.innerHTML=originalHTML;btn.style.background=''},2000)}).catch(()=>{btn.disabled=!1;btn.innerHTML=originalHTML;alert('Error adding product to cart. Please try again.')})});card.querySelector('.trending-products__btn--buy')?.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();const select=card.querySelector('.trending-products__select');const variantId=select?.value||this.dataset.variantId;if(!variantId){alert('Please select a variant.');return}
this.disabled=!0;this.innerHTML='PROCESSING...';buyNowSingle(variantId,1)});initTooltip(card,'.notes','.ribbon','.custom-tooltip','#card_details',{show:['active-tooltip','blur'],hide:['card_details']});initTooltip(card,'.notes1-horizantal','.ribbon1-horizantal','.custom-tooltip-horizontal','#card-horizontal',{show:['active-tooltip-horizantal','blur-horizantal'],hide:[]})}
function initTooltip(card,containerSel,ribbonSel,tooltipSel,detailsSel,classes){const container=card.querySelector(containerSel);if(!container)return;const ribbon=container.querySelector(ribbonSel);const tooltip=container.querySelector(tooltipSel);const details=card.querySelector(detailsSel);if(!ribbon||!tooltip||!details)return;const show=()=>{tooltip.style.display='block';ribbon.classList.add(classes.show[0]);details.classList.add(classes.show[1]);classes.hide.forEach(c=>details.classList.remove(c))};const hide=()=>{setTimeout(()=>{if(!ribbon.matches(':hover')&&!tooltip.matches(':hover')){tooltip.style.display='none';ribbon.classList.remove(classes.show[0]);details.classList.remove(classes.show[1]);classes.hide.forEach(c=>details.classList.add(c))}},100)};container.addEventListener('mouseenter',show);container.addEventListener('mouseleave',hide);tooltip.addEventListener('mouseenter',show);tooltip.addEventListener('mouseleave',hide)}
function initDiscoveryCards(){document.querySelectorAll(SELECTORS.discoveryCard).forEach(card=>{card.querySelector('.discovery-set-btn--cart')?.addEventListener('click',async function(e){e.preventDefault();const btn=this;const originalText=btn.textContent;const variantId=btn.dataset.variantId;btn.disabled=!0;btn.textContent='ADDING...';try{const r=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:variantId,quantity:1})});if(r.ok){const data=await r.json();const count=document.querySelector('.cart-count,[data-cart-count]');if(count){const cart=await fetch('/cart.js').then(r=>r.json());count.textContent=cart.item_count}
btn.textContent='✓ ADDED';setTimeout(()=>{btn.textContent=originalText;btn.disabled=!1},2000);document.dispatchEvent(new CustomEvent('cart:updated',{detail:{item:data}}))}else throw new Error()}catch{btn.textContent='ERROR';setTimeout(()=>{btn.textContent=originalText;btn.disabled=!1},2000)}});card.querySelector('.discovery-set-btn--buy')?.addEventListener('click',async function(e){e.preventDefault();const btn=this;const originalText=btn.textContent;btn.disabled=!0;btn.textContent='PROCESSING...';try{const r=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:btn.dataset.variantId,quantity:1})});if(r.ok)location.href='/checkout';else throw new Error()}catch{btn.textContent='ERROR';setTimeout(()=>{btn.textContent=originalText;btn.disabled=!1},2000)}})})}
function initializeAllCards(){document.querySelectorAll(SELECTORS.card).forEach(initializeCard);initDiscoveryCards()}
function setupObserver(){let pending=[];let scheduled=!1;const processPending=()=>{pending.forEach(initializeCard);pending=[];scheduled=!1};new MutationObserver(mutations=>{for(const m of mutations){for(const node of m.addedNodes){if(node.nodeType!==1)continue;if(node.matches?.(SELECTORS.card))pending.push(node);node.querySelectorAll?.(SELECTORS.card).forEach(c=>pending.push(c))}}
if(pending.length&&!scheduled){scheduled=!0;requestAnimationFrame(processPending)}}).observe(document.body,{childList:!0,subtree:!0})}
function init(){initializeAllCards();setupObserver()}
if('requestIdleCallback' in window){requestIdleCallback(init,{timeout:2500})}else{requestAnimationFrame(()=>requestAnimationFrame(init))}
window.initializeProductCards=initializeAllCards;window.updateCartCount=updateCartCount})()